/* src/app/private/components/academic-year/delete-academic-year/delete-academic-year.component.scss */
/*# sourceMappingURL=delete-academic-year.component.css.map */
